import React, { useEffect, useRef, useState } from "react";

const LocalDimensionsContainer: React.FC<{
  children: React.ReactElement;
  variant?: "default" | "modern";
}> = ({ children, variant = "default" }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [size, setSize] = useState<{ height: number; width: number } | null>(
    null
  );

  useEffect(() => {
    const measure = () => {
      if (containerRef.current) {
        setSize({
          height: containerRef.current.offsetHeight,
          width: containerRef.current.offsetWidth,
        });
      }
    };
    const id = window.setTimeout(measure, 50);
    window.addEventListener("resize", measure);
    return () => {
      window.clearTimeout(id);
      window.removeEventListener("resize", measure);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        flex: "1 1 auto",
        minHeight: 0,
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {size &&
        React.cloneElement(children, {
          height: size.height,
          width: size.width,
          variant,
        })}
    </div>
  );
};

export default LocalDimensionsContainer;
